const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'brands',
  recordClass: require('./record'),
  relations: {
    hasOne: {
      brand_time_series: {
        foreignKey: 'brand_id',
        localField: 'brand_time_series'
      },
      campaign_impressions: {
        foreignKey: 'brand_id',
        localField: 'campaign_impressions'
      },
      pulse_aggregates: {
        foreignKey: 'brand_id',
        localField: 'pulse_aggregates'
      },
      pulse_social_statistics: {
        foreignKey: 'brand_id',
        localField: 'pulse_social_statistics'
      }
    },
    hasMany: {
      content_discovery_item: {
        foreignKey: 'brand_id',
        localField: 'content_discovery_items'
      },
      retailer: {
        foreignKey: 'brand_id',
        localField: 'retailers'
      },
      allocation_detail: {
        foreignKey: 'brand_id',
        localField: 'allocation_details'
      },
      division: {
        foreignKey: 'brand_id',
        localField: 'divisions'
      },
      group: {
        foreignKey: 'brand_id',
        localField: 'groups'
      },
      smart_group: {
        foreignKey: 'brand_id',
        localField: 'smart_groups'
      },
      brand_request: {
        foreignKey: 'brand_id',
        localField: 'brand_requests'
      },
      note: {
        foreignKey: 'brand_id',
        localField: 'notes'
      },
      registration_key: {
        foreignKey: 'brand_id',
        localField: 'registration_keys'
      },
      digital_asset: {
        foreignKey: 'brand_id',
        localField: 'digital_assets'
      },
      asset: {
        foreignKey: 'brand_id',
        localField: 'assets'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('brand', mapper_options)
  addActions({
    accept_all_brand_requests: {
      pathname: 'brand_requests/batch_accept',
      method: 'PUT'
    },
    revoke_all_brand_requests: {
      pathname: 'brand_requests/batch_revoke',
      method: 'PUT'
    },
    reaccept_all_brand_requests: {
      pathname: 'brand_requests/batch_reaccept',
      method: 'PUT'
    }
  })(mapper)
}
